const TermsConditions = () => {
  return (
    <section className="flex justify-center py-14">
      <div className="container 3xl:w-[70%] p-4 xl:px-20 space-y-4 text-base sm:text-lg md:text-xl lg:text-2xl space-y-4 py-4">
        <h2 className="font-bold text-xl">TERMS &amp; CONDITIONS</h2>

        <p>
          <strong>1. Payment:</strong> 100% payment is required against the
          invoice. Sponsorship/exhibition space and associated benefits will be
          confirmed only on receipt of payment.
        </p>

        <p>
          <strong>2. Benefits:</strong> The sponsor/exhibitor will receive only
          the benefits specified in the applicable sponsorship/package mentioned
          in the invoice. Benefits are non-transferable and cannot be exchanged
          for cash or other benefits.
        </p>

        <p>
          <strong>3. Media &amp; Editorial Benefits:</strong> All Zee Media/WION
          benefits are subject to applicable editorial, programming, scheduling
          and technical requirements.
        </p>

        <p>
          <strong>4. Zee Media Deliverables:</strong> In case of Zee Media (WION
          / Zee News / Zee Business) benefits, all creatives will be produced by
          Zee Media.
        </p>

        <p>
          <strong>5. Delivery Conditions:</strong> Fulfilment of the Zee Media
          deliverables is subject to the Sponsor providing complete and approved
          materials by the stipulated deadlines.
        </p>

        <p>
          <strong>6. Company Material:</strong> Logos, advertisements, profiles,
          videos and other material must be supplied by the sponsor within the
          timelines specified by IMR.
        </p>

        <p>
          <strong>7. Cancellation and Refunds:</strong> Cancellation by the
          sponsor after confirmation will attract the 25% of the total amount in
          the invoice as cancellation charges.
          <br />
          <br />
          Amounts already paid and forfeited under the cancellation policy will
          not be refundable.
        </p>

        <p>
          <strong>8. Event Changes:</strong> IMR reserves the right to modify
          the programme, speakers, venue/meetings arrangements or schedule where
          circumstances require.
        </p>

        <p>
          <strong>9. Exhibition:</strong> Exhibition space will be allotted by
          IMR. Booth construction, branding and other exhibitor requirements
          must comply with the venue&apos;s rules and timelines.
        </p>

        <p>
          <strong>10. Taxes:</strong> GST to be paid on Reverse Charge Mechanism
          (RCM) are the responsibility of the client.
        </p>

        <p>
          <strong>11. Acceptance:</strong> Payment against this invoice
          constitutes acceptance of these Terms &amp; Conditions and the
          applicable sponsorship/exhibition package.
        </p>
      </div>
    </section>
  );
};

export default TermsConditions;
